/**
 * IMPACT REPORT CUSTOM COMPONENT REGISTRY
 *
 * This registry maps string identifiers to actual React components for
 * dynamic component resolution at runtime for impact reports. It serves as
 * the bridge between JSON configuration and actual React components for this
 * specific report type.
 *
 * DESIGN BENEFITS:
 * - Report-specific: Each report type can have its own component registry
 * - Co-located: Registry lives alongside the injection config for better organization
 * - Modular: Changes to custom components don't affect other report types
 * - JSON-driven: Configurations reference components through string identifiers
 * - Type-safe: Import errors caught at build time, not runtime
 * - Versatile: Works with the reusable ReportDocument component
 *
 * HOW TO ADD NEW IMPACT REPORT CUSTOM COMPONENTS:
 * 1. Create your custom component in ./custom_report_components/
 * 2. Import it in this file
 * 3. Add an entry to CUSTOM_COMPONENT_REGISTRY with a unique string identifier
 * 4. Use the identifier in injectionConfig.json
 *
 * EXAMPLE:
 * import MyImpactChart from './custom_report_components/MyImpactChart';
 *
 * export const CUSTOM_COMPONENT_REGISTRY = {
 *     'impact-chart': MyImpactChart,
 *     'impact-analysis': ImpactAnalysisComponent,
 * };
 */

import React from 'react'

// Impact Report Custom Component Registry
// Maps type strings to React components for dynamic injection in impact reports

// Import custom components for impact reports
import IndependentDriversList from './custom_report_components/IndependentDriversList'

// Define the component registry type
export type CustomComponentRegistry = {
  [key: string]: React.ComponentType<any>
}

// Component mapping for impact report custom components - add new custom components here
export const CUSTOM_COMPONENT_REGISTRY: CustomComponentRegistry = {
  // Independent drivers listing component
  'independent-drivers-list': IndependentDriversList,
}
